import type { VariantProps } from "class-variance-authority";
import type { IconName } from "lucide-react/dynamic";

import { cva } from "class-variance-authority";
import { DynamicIcon } from "lucide-react/dynamic";

export const featuredIconVariants = cva(
  "pointer-events-none grid shrink-0 place-content-center rounded-full select-none",
  {
    variants: {
      variant: {
        primary: "bg-brand-primary-100 text-brand-primary-500",
        success: "bg-success-extra-light text-success",
        warning: "bg-warning-extra-light text-warning",
        error: "bg-error-extra-light text-error",
        disabled: "bg-gray-100 text-gray-400",
        muted: "bg-white text-gray-400",
        white: "bg-white text-gray-800 shadow-sm",
        light: "bg-gray-100 text-gray-800",
        dark: "bg-gray-800 text-white",
      },
      size: {
        xs: "size-6 p-1.5",
        sm: "size-8 p-2",
        md: "size-10 p-2.5",
        lg: "size-12 p-3",
        xl: "size-14 p-3.5",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
    },
  },
);

const iconVariants = cva("shrink-0", {
  variants: {
    size: {
      xs: "size-3",
      sm: "size-4",
      md: "size-5",
      lg: "size-6",
      xl: "size-7",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

type Props = React.ComponentPropsWithoutRef<"div"> &
  VariantProps<typeof featuredIconVariants> & {
    icon: IconName;
  };

export default function FeaturedIcon({
  icon,
  variant,
  size,
  className,
  ...props
}: Props) {
  return (
    <div
      data-slot="featured-icon"
      className={featuredIconVariants({ variant, size, className })}
      {...props}
    >
      <DynamicIcon name={icon} className={iconVariants({ size })} />
    </div>
  );
}
